import { useDispatch } from 'react-redux';
import {
  Box,
  Button,
  Container,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { deleteUserApi, searchUsers } from '../../../redux/slice/adminSlice';
import styles from '../../../assets/styles/resetPassword';
import CustomTypography from '../../../components/Typography/typography';

const DeleteUser = ({ open, handlePopUp, user, page, rowsPerPage, deferredValue }: any) => {
  const classes = styles();
  const dispatch = useDispatch();

  const onDeleteConfirm = async () => {
    try {
      // Wait until user deletion is completed
      await dispatch(deleteUserApi({ id: user._id })).unwrap();

      // Then fetch updated user list
      await dispatch(searchUsers({ page, rowsPerPage, deferredValue }));

      // Finally, close the popup
      handlePopUp();
    } catch (error) {
      console.error('❌ Delete failed:', error);
    }
  };


  return (
    <Container maxWidth="xs">
      <Modal
        open={open}
        onClose={handlePopUp}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.boxClass}>
          {/* <CustomTypography align="center" variant="h5" component="div">
            <LockResetIcon fontSize="large" color="primary" />
          </CustomTypography> */}

          <CustomTypography align="center" variant="h5" component="h2">
            Delete User
          </CustomTypography>

          <Typography align="center" sx={{ mt: 2 }}>
            Are you sure you want to delete this user?
          </Typography>

          <Grid container spacing={2} justifyContent="center" sx={{ mt: 3 }}>
            <Grid item>
              <Button
                variant="contained"
                color="error"
                onClick={onDeleteConfirm}
              >
                Yes, Delete
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={handlePopUp}>
                Cancel
              </Button>
            </Grid>
          </Grid>

          <div onClick={handlePopUp}>
            <CloseIcon
              fontSize="large"
              className={classes.closeIconClass}
              color="error"
            />
          </div>
        </Box>
      </Modal>
    </Container>
  );
};

export default DeleteUser;
